import { PaymentPlan } from "./paymentPlan";
import { PlanInfo } from "./planInfo";

export class GetPaymentPlans {
    monthly: PlanInfo = new PlanInfo();
    yearly: PlanInfo = new PlanInfo();
}